import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/root/App";

// Production build'de console.log çıktısını devre dışı bırak
if (process.env.NODE_ENV === "production") {
  /* eslint-disable no-console */
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

